import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SharedService} from './shared.service';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class AdminService{

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) {
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      if (!error.error) {
        error.error= { message: 'Some error occurred, you may not have permission to access this action.'}
      }
      if (error.error && !error.error.message) {
        error.error= { message: 'Some error occurred, you may not have permission to access this action.'}
      }

      return of(error as T);
    };
  }

  public getLMFSortByField(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/lmf/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getLMFSortByField', {})),
    );
  }

  public getTransferDays(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/transfer/days/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getTransferDays', {})),
    );
  }

  public getInternationalZonePricingDiscount(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/international/zone/pricing/discount/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricingDiscount', {})),
    );
  }

  public getInternationalZonePricing(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/international/zone/pricing/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricing', {})),
    );
  }

  public getInternationalZonePricingForInstitution(field:any,offset:any,page:any,institution:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'institution/'+institution+'/international/zone/pricing/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricing', {})),
    );
  }

  public getEnginePricings(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/engine/pricing/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getEnginePricings', {})),
    );
  }

  public getEnginePricingsCOU(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/engine/pricing-cou/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getEnginePricings', {})),
    );
  }

  public getBookings(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/booking/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getBookings', {})),
    );
  }

  public deleteDiscount(discountID:any){
    return  this.http.delete(this.sharedService.getFranchiseUrl() + 'admin/international/discount/'+discountID+'/pricing', this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteDiscount', {})),
    );
  }

  public findDistinctZone(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/zones', this.jsonOptions).pipe(
      catchError(this.handleError<any>('findDistinctZone', {})),
    );
  }

  public createDiscount(createObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/international/discount', createObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('createDiscount', {})),
    );
  }

  public bookingStats(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/booking/stats', this.jsonOptions).pipe(
      catchError(this.handleError<any>('bookingStats', {})),
    );
  }

  public bookingStatsForAdmin(filter:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/booking/stats',filter, this.jsonOptions).pipe(
      catchError(this.handleError<any>('bookingStats', {})),
    );
  }

   public bookingStatsForInfluencer(salesCode:any, filter:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'session/influencer/' + salesCode + '/booking/stats', filter, this.jsonOptions).pipe(
      catchError(this.handleError<any>('bookingStats', {})),
    );
  }

  public statistics(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/stats', this.jsonOptions).pipe(
      catchError(this.handleError<any>('bookingStats', {})),
    );
  }

  public influencerStatistics(salesCode:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'session/influencer/' + salesCode + '/customer/stats', this.jsonOptions).pipe(
      catchError(this.handleError<any>('bookingStats', {})),
    );
  }

  public adminStatistics(filter:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/stats', filter, this.jsonOptions).pipe(
      catchError(this.handleError<any>('bookingStats', {})),
    );
  }

  public submitLMF(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/lmf', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitLMF', {})),
    );
  }

  public submitSalesCodes(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/salescode', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitSalesCodes', {})),
    );
  }

  public submitTransferDay(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/transfer/day/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitTransferDay', {})),
    );
  }

  public submitInternationalZone(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/international/zone/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitInternationalZone', {})),
    );
  }

  public submitInternationalZoneForInstitution(file:any,institutionId:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'institution/ '+institutionId.trim()+' /upload/international/zone/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitInternationalZone', {})),
    );
  }

  public submitEnginePricing(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitInternationalZone', {})),
    );
  }

  public submitCOUEnginePricing(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/counter/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitInternationalZone', {})),
    );
  }

  /*public getUsers(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/users/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions.pipe(
      catchError(this.handleError<any>('getUsers', {})),
    );
  }*/

  public getUsers(body: any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/view/users/with/filters', body, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getUsers', {})),
    );
  }

  public getInfluencerUsers(body: any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'session/influencer/users', body, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getUsers', {})),
    );
  }
  

  public viewSingleUser(userId:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/single/user/'+userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('viewSingleUser', {})),
    );
  }

  public grantPermission(permissionObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/permission/grant', permissionObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('grantPermission', {})),
    );
  }

  public grantRole(roleObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/role/grant', roleObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('grantRole', {})),
    );
  }

  public exportLMF(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/lmf', this.jsonOptions).pipe(
      catchError(this.handleError<any>('exportLMF', {})),
    );
  }

  public downloadLMFTemplate(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/lmf/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadLMFTemplate', {})),
    );
  }

  public downloadTransferDaysTemplate(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/transferdays/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadTransferDaysTemplate', {})),
    );
  }

  public downloadTransferDaysFile(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/transferdays', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadTransferDaysFile', {})),
    );
  }

  public downloadZoneRateTemplate(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/zone/rate/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadZoneRateTemplate', {})),
    );
  }

  public downloadSalesCodeTemplate(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/salescode/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadSalesCodeTemplate', {})),
    );
  }

  public downloadZoneRateFile(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/zone/rate', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadZoneRateFile', {})),
    );
  }

  public downloadEnginePricingTemplate(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/engine/pricing/template', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadEnginePricingTemplate', {})),
    );
  }

  public downloadEnginePricingFile(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/engine/pricing', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadEnginePricingFile', {})),
    );
  }

  public downloadEnginePricingCOUFile(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/engine/pricing-cou', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadEnginePricingFile', {})),
    );
  }

  public getSalesCodes(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/sales/codes/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getSalesCodes', {})),
    );
  }

  public getSalesCodesWithFilters(filters:any){
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/all/sales/code/filter',filters,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getSalesCodesWithFilters', {}))
    );
  }

  public createSaleCode(saleCodeObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/sale/code',saleCodeObj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('createSaleCode', {})),
    );
  }

  public editSaleCode(saleCodeObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/edit/sales/code',saleCodeObj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('editSaleCode', {})),
    );
  }

  public createAdmin(createObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/register/admin', createObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('createAdmin', {})),
    );
  }

  public getAllUsersFile(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/all/users', this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllUsersFile', {})),
    );
  }

  public updateUserWallet(updateWalletObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/update/wallet', updateWalletObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateUserWallet', {})),
    );
  }


  public updateInstitutionStoreWallet(updateWalletObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/update/institution/store/wallet', updateWalletObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateInstitutionStoreWallet', {})),
    );
  }


  public processWaybill(trackNo:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/process/waybill/'+trackNo, '',this.jsonOptions).pipe(
      catchError(this.handleError<any>('processWaybill', {})),
    );
  }

  public getFiles(filesName:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/historical/files/'+filesName, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getFiles', {})),
    );
  }

  public downloadHistoricalFile(filesName:any,file:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/historical/files/'+filesName+"/download/"+file, this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadHistoricalFile', {})),
    );
  }

  public exportSalesCodesFile(statuses: any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/download/sales/code', statuses, this.jsonOptions).pipe(
      catchError(this.handleError<any>('exportSalesCodesFile', {})),
    );
  }

  public toggleParcelStickerRequirement(userId: string){
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'admin/toggle/add/parcel/stickers/' + userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('toggleParcelStickerRequirement', {})),
    );
  }

  public activateDeactivateUser(userId: string){
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'admin/update/user/status/' + userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('activateDeactivateUser', {})),
    );
  }

  public getWalletsTransaction(viewFilter:object){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/wallet/transaction',viewFilter, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletsTransaction', {})),
    );
  }

  exportWalletsTransaction(viewFilter:object) {
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/download/all/wallet/transaction',viewFilter, this.jsonOptions).pipe(
      catchError(this.handleError<any>('exportWalletsTransaction', {})),
    );
  }

  public getAllWalletsTransactionForSingleUser(userId:string,filter:object){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/wallets/transaction/individual/'+userId, filter,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllWalletsTransactionForSingleUser', {})),
    );
  }

  createSalesAgent(salesAgent:any) {
   return this.http.post(this.sharedService.getFranchiseUrl()+'admin/register/sales/agent',salesAgent,this.jsonOptions).pipe(
     catchError(this.handleError<any>('createSalesAgent', {})),
   );
  }

  getAllAvailableSalesCode() {
    return this.http.get(this.sharedService.getFranchiseUrl()+'admin/get/all/available/sales/code',this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllAvailableSalesCode', {})),
      );
  }

  changeUserSalesCode(selectedUserId: any, changeNewSalesCode: any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'admin/change/sales/code/for/'+selectedUserId+'/to/'+changeNewSalesCode,this.jsonOptions).pipe(
      catchError(this.handleError<any>('changeUserSalesCode', {})),
    );
  }

  updateUserDetails(selectedUserId: any, user:any) {
    return this.http.put(this.sharedService.getFranchiseUrl()+'admin/update/user/info/'+selectedUserId,user,this.jsonOptions).pipe(
      catchError(this.handleError<any>('UpdateUserDetails', {})),
    );
  }

  updateSalesCodeForIndividual(selectedUserId: any, changeNewSalesCode: any) {
   return this.http.put(this.sharedService.getFranchiseUrl()+'admin/change/individual/sales/code/'+selectedUserId+'/'+changeNewSalesCode,
     this.jsonOptions).pipe(
     catchError(this.handleError<any>('updateSalesCodeForIndividual', {})),
   );
  }

  searchForBooking(searchBooking: any) {
    return this.http.get(this.sharedService.getFranchiseUrl()+'admin/search/'+searchBooking,this.jsonOptions).pipe(
      catchError(this.handleError<any>('searchForBooking', {})),
    );
  }

  exportWalletsBalances() {
    return this.http.get(this.sharedService.getFranchiseUrl()+'admin/download/wallet/balances',this.jsonOptions).pipe(
      catchError(this.handleError<any>('exportWalletsBalances', {})),
    );
  }

  getAdminActions() {
    return  this.http.get(this.sharedService.getFranchiseUrl()+'admin/all/admin/actions',this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAdminActions', {})),
    );
  }

  getUsersWaybill(userID: any) {
    return  this.http.get(this.sharedService.getFranchiseUrl()+'admin/user/waybills/'+userID,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getUsersWaybill', {})),
    );
  }

  public preLoadWalletRequest(storeId: any, walletRequest:any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/load/store/'+storeId+'/wallet', walletRequest, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletTransactions', {}))
    );

  }

  getAllBookingsWithFilters(obj:any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'admin/get/all/bookings',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
    );
  }

  getAllInfluencerBookingsWithFilters(obj:any, salesCode:any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'session/influencer/'+salesCode+'/get/all/bookings',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
    );
  }

  getAdminActionsWithFilter(obj:any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'admin/all/admin/actions',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('adminActions', {})),
    );
  }

  exportAdminActionsWithFilter(obj:any) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/download/actions',obj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('exportAdminActionsWithFilter', {})),
    );
  }

  getAllBookingsFile(obj:any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'admin/download/bookings',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadBookingsWithFilter', {})),
    );
  }

   getAllInfluencerBookingsFile(searchSalesCode:any, obj:any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'session/influencer/'+searchSalesCode+'/bookings/export',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadBookingsWithFilter', {})),
    );
  }

  public submitImportZone(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/import/zone/countries', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitLMF', {})),
    );
  }

  public getImportZoneSortByField(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/zone/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getLMFSortByField', {})),
    );
  }

  public getImportZonesByZone(zone:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/zone/'+zone, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getLMFSortByField', {})),
    );
  }

  public createImportDiscount(createObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/import/discount', createObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('createImportDiscount', {})),
    );
  }

  public getImportZonePricing(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/zone/pricing/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricing', {})),
    );
  }

  public getImportZoneDocumentPricing(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/zone/document/pricing/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricing', {})),
    );
  }

  public getImportZonePricingDiscount(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/zone/pricing/discount/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getImportZonePricingDiscount', {})),
    );
  }

  
  public deleteAllImportDiscount(){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/import/discount/pricing/delete/all', this.jsonOptions).pipe(
      catchError(this.handleError<any>('getImportZonePricingDiscount', {})),
    );
  }
  public deleteImportDiscount(discountID:any){
    return  this.http.delete(this.sharedService.getFranchiseUrl() + 'admin/import/discount/'+discountID+'/pricing', this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteImportDiscount', {})),
    );
  }

  public deleteBusinessUserDiscount(discountID:any){
    return  this.http.delete(this.sharedService.getFranchiseUrl() + 'admin/business-user/discount/'+discountID, this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteImportDiscount', {})),
    );
  }

  public deleteMultipleImportDiscount(zones:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/multiple/import/discount/pricing/delete', zones, this.jsonOptions).pipe(
      catchError(this.handleError<any>('deleteImportDiscount', {})),
    );
  }
  public submitImportZonePrice(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/import/zone/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitImportZone', {})),
    );
  }

  public submitImportZoneDocumentPrice(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/import/zone/document/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitImportZoneDocumentPrice', {})),
    );
  }

  public createDiscountProfile(createObj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/import/discount/profile', createObj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('createImportDiscountProfile', {})),
    );
  }

  public getImportDiscountProfiles(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/discount/profile/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getImportDiscountProfile', {})),
    );
  }

  public getImportClients(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/discount/profile/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getImportDiscountProfile', {})),
    );
  }
  getAllImportBookingsWithFilters(obj:any) {
    return this.http.post(this.sharedService.getFranchiseUrl()+'admin/get/all/import/bookings',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllImportBookingsWithFilters', {})),
    );
  }

  public updateUserType(userId: string, userType: string){
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'admin/update/user/type/' + userId + '/'+userType, this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateUserType', {})),
    );
  }

  public getAllBusinessUsers(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/get/all/business-users/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllBusinessUsers', {})),
    );
  }

  public getAllCatalogues(body: any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/business-user/catalogues', body, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllBusinessUserCatalogues', {})),
    );
  }

  getCatalogue(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/business-user/' + id + '/catalogue', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCatalogue', []))
    );
  }

   getUserCatalogue(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'session/business-user/' + id + '/catalogue', this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCatalogue', []))
    );
  }

   createDefaultCatalogue(obj: any, id: any): Observable<any> {
      return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/business-user/' + id + '/create/default/catalogue', obj, this.jsonOptions ).pipe(
        catchError(this.handleError<any[]>('createDefaultCatalogue', []))
      );
    }

    createCatalogue(obj: any, id: any): Observable<any> {
      return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/business-user/' + id + '/create/catalogue', obj, this.jsonOptions ).pipe(
        catchError(this.handleError<any[]>('createCatalogue', []))
      );
    }

    editCatalogue(id: any, catalogue: any,catalogueId: any): Observable<any> {
      return this.http.put(this.sharedService.getFranchiseUrl() + 'admin/business-user/' + id + '/catalogue/'+catalogueId,catalogue, this.jsonOptions).pipe(
        catchError(this.handleError<any[]>('editCatalogue', []))
      );
    }

    deleteCatalogue(id: any, catalogueId: any): Observable<any> {
      return this.http.delete(this.sharedService.getFranchiseUrl() + 'admin/business-user/' + id + '/catalogue/'+catalogueId, this.jsonOptions).pipe(
        catchError(this.handleError<any[]>('deleteCatalogue', []))
      );
    }

    createBusinessPricing(obj: any,id:any): Observable<any> {
      return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/business-user/'+id+'/create/pricing', obj, this.jsonOptions ).pipe(
        catchError(this.handleError<any[]>('createCatalogue', []))
      );
    }
    editBusinessPricing(id: any, catalogue: any,catalogueId: any): Observable<any> {
      return this.http.put(this.sharedService.getFranchiseUrl() + 'admin/business-user/' + id + '/pricing/'+catalogueId,catalogue, this.jsonOptions).pipe(
        catchError(this.handleError<any[]>('editCatalogue', []))
      );
    }
    public getAllBusinessPricing(body: any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/business-user/pricing', body, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllBusinessUserCatalogues', {})),
    );
  }

  createBusinessDiscount(obj: any,id:any): Observable<any> {
      return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/business-user/'+id+'/create/discount', obj, this.jsonOptions ).pipe(
        catchError(this.handleError<any[]>('createCatalogue', []))
      );
    }


  public getAllBusinessDiscount(body: any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/business-user/discount', body, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getAllBusinessUserCatalogues', {})),
    );
  }

    isSkynetCommercial(salecode: any): Observable<any> {
      return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/salecode/' + salecode , this.jsonOptions).pipe(
        catchError(this.handleError<any[]>('isSkynetCommercial', []))
      );
    }
    
    getBookingsInRange(obj:any) {
      return this.http.post(this.sharedService.getFranchiseUrl()+'admin/get/bookings/range',obj,this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

    public getImportSurcharges(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/import/surcharges/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getImportSurcharges', {})),
    );
  }

    createSurcharge(obj:any) {
      return this.http.post(this.sharedService.getFranchiseUrl()+'admin/import/surcharges',obj,this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

    updateSurcharge(obj:any) {
      return this.http.put(this.sharedService.getFranchiseUrl()+'admin/import/surcharges',obj,this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

    public createBooking(bookingDetails: any): Observable<any> {
        return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/booking/create', bookingDetails, this.jsonOptions).pipe(
          catchError(this.handleError<any[]>('createBooking', []))
        );
    }


    public processBooking(trackNo: any): Observable<any> {
        return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/booking/create/process/' + trackNo, {}, this.jsonOptions).pipe(
          catchError(this.handleError<any[]>('createBooking', []))
        );
    }

    createMauritiusDomesticRate(obj:any) {
      return this.http.post(this.sharedService.getFranchiseUrl()+'admin/domestic/rate',obj,this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

    updateMauritiusDomesticRate(obj:any) {
      return this.http.put(this.sharedService.getFranchiseUrl()+'admin/domestic/rate',obj,this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

    public getMauritusRates(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/domestic/rate/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getImportSurcharges', {})),
    );
  }

    createFuelSurcharge(obj:any) {
      return this.http.post(this.sharedService.getFranchiseUrl()+'admin/booking/fuel/surcharges',obj,this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

     getFuelSurcharge() {
      return this.http.get(this.sharedService.getFranchiseUrl()+'admin/booking/fuel/surcharges',this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

    updateFuelSurcharge(obj:any) {
      return this.http.put(this.sharedService.getFranchiseUrl()+'admin/booking/fuel/surcharges',obj,this.jsonOptions).pipe(
        catchError(this.handleError<any>('getAllBookingsWithFilters', {})),
      );
    }

    public downloadImportZoneRateFile(){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/download/import/zone/rate', this.jsonOptions).pipe(
      catchError(this.handleError<any>('downloadZoneRateFile', {})),
    );
  }

  createDefaultAdminCatalogues(catalogue:any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/default/catalogue',catalogue, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCatalogue', []))
    );
  }

  getDefaultCatalogues(): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'admin/default/catalogue',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getCatalogue', []))
    );
  }

  public getWalletBalances(viewFilter:object){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/wallet/balance',viewFilter, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getWalletsTransaction', {})),
    );
  }

  public linkUser(obj:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/link/user',obj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('linkUser', {})),
    );
  }

  public updateInHouseCode(userId: string, inHouseCode: string){
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'admin/update/user/inhouse/code/' + userId + '/'+inHouseCode, this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateInHouseCode', {})),
    );
  }

  public updateUser(userId: string, obj: any){
    return  this.http.put(this.sharedService.getFranchiseUrl() + 'admin/update/user/' + userId ,obj, this.jsonOptions).pipe(
      catchError(this.handleError<any>('updateUserDetails', {})),
    );
  }

   public getMauritiusExportPricing(field:any,offset:any,page:any){
    return  this.http.get(this.sharedService.getFranchiseUrl() + 'admin/mauritius/pricing/sort/'+field+'/offset/'+offset+'/page/'+page, this.jsonOptions).pipe(
      catchError(this.handleError<any>('getInternationalZonePricing', {})),
    );
  }

   public submitMauritusEnginePricing(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/mauritius/engine/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitMauritusEnginePricing', {})),
    );
  }

  public submitMauritiusExport(file:any){
    return  this.http.post(this.sharedService.getFranchiseUrl() + 'admin/upload/mauritius/engine/pricing', file,{
      headers: new HttpHeaders().set('Accept', 'application/json')
    }).pipe(
      catchError(this.handleError<any>('submitInternationalZone', {})),
    );
  }

  
}
